import React, { useEffect, useRef } from 'react'
import heroImage1 from '../../../assets/images/hero-img-1.png'

const HeroSection = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = heroRef.current?.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="hero" className='hero-section' ref={heroRef}>
      {/* Background Elements */}
      <div className="hero-gradient-bg"></div>
      <div className="hero-grid-pattern"></div>
      <div className="hero-glow hero-glow-1"></div>
      <div className="hero-glow hero-glow-2"></div>
      
      <div className="container hero-content">
        <div className="hero-layout">
          {/* Left Content */}
          <div className="hero-text-content">
            <div className="hero-badge animate-on-scroll">
              <span className="badge-dot"></span>
              The Future of Shooting Sports
            </div>
            
            <h1 className="hero-title animate-on-scroll">
              Elevate Your
              <span className="hero-title-highlight"> Shooting </span>
              Performance
            </h1>
            
            <p className="hero-subtitle animate-on-scroll">
              Track scores, connect with clubs, manage equipment, and compete with shooters worldwide. 
              Shoot Connect is fully mobile responsive, so you can pick up your scoring, venue search, and account management on any device.
            </p>
            
            <div className="hero-cta-group animate-on-scroll">
              <a href="/register" className="hero-cta-primary">
                Get Started Free
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </a>
              <a href="#features" className="hero-cta-secondary">
                See Features
              </a>
            </div>
            
          </div>
          
          {/* Right Content - Responsive Preview */}
          <div className="hero-visual animate-on-scroll">
            <div className="hero-phone-wrapper">
              <div className="phone-glow"></div>
              <img src={heroImage1} alt="Shoot Connect responsive preview" className="hero-phone-image" />
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="scroll-mouse">
          <div className="scroll-wheel"></div>
        </div>
        <span>Scroll to explore</span>
      </div>
    </section>
  )
}

export default HeroSection
